<!--  
  This module is shared between WyneCellar and WyneTaster
  For WyneCellar set allowBuy: true
  For WyneTaster set allowBuy: false
-->
<template>
  <div v-on:contextmenu.prevent="doNothing">
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')"
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
          </b-col>
        </b-row>        
        <b-row>
          <b-col md="10" style="padding:0" align="center">
            <p class="w-pagetitle" style="margin-left:20px;margin-right:20px; text-align:right;">{{ translate("wishlist") }}</p>
            <b-row class="justify-content-center">
              <p class="t-title" style="width: 90%;text-align: center;">{{ translate("wishlist of bottles you want to buy") }}</p>
            </b-row>
            <b-row class="justify-content-center">
              <p class="t-subtitle" style="width:90%; text-align: center;">{{ translate("to select one, click - to add one, click on the plus sign") }}</p>
            </b-row>  
            <b-row class="justify-content-center" style="margin:0">
              <b-col
                  class="w-tile m-2 d-inline-flex justify-content-center"
                  xs="12" sm="6" md="4" lg="2" xl="2"
                  v-on:click="onEdit(0)"
                  style ="display:block; margin:20px !important"
              >
                <b-img
                  width=300px
                  height=200px
                  :src="require('@/assets/img/plus.png')"
                >
                </b-img>
              </b-col>              
              <b-col
                v-for="(bottle, index) in bottles"
                v-bind:item="bottle"
                v-bind:index="index"
                v-bind:key="bottle._id" 
                class="w-tile m-2 d-inline-flex justify-content-center w-cursor-click"
                xs="12" sm="6" md="4" lg="2" xl="2"
                style ="display:block; min-width:300px; margin:20px !important"
              >
                <b-row 
                  style="width:100%"
                  v-on:click="onSelect(index)"
                >
                  <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
                    <b-img center v-if="bottle.image_files[0]"
                      style="height:100%;width:auto;position:absolute;right:0px"
                      v-bind:src="bottle.image_files[0].dataURL" 
                    ></b-img>
                    <div v-else>
                      <b-img center v-if="bottle.color == 'Red'"
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/bottle_red.png')"
                      ></b-img>
                      <b-img center v-else-if="bottle.color == 'White'"
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/bottle_white.png')"
                      ></b-img>
                      <b-img center v-else-if="bottle.color == 'Rosé'"
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/bottle_rose.png')"
                      ></b-img>
                      <b-img center v-else
                        style="height:100%;width:auto;position:absolute;right:0px"
                        :src="require('@/assets/img/bottle.png')"
                      ></b-img>
                    </div>
                  </b-col>
                  <!-- <b-col cols="9" class="d-table-cell"> -->
                  <b-col cols="9">  
                    <div style="width:75%">
                      <p class="t-title">{{bottle.vintage}}</p>
                      <p class="t-title" style="margin:0">{{bottle.name}}</p>
                      <p v-if="bottle.type" class="t-subtitle">{{bottle.type}}</p>
                      <p v-else class="t-subtitle" style="color:white">bogus text here</p>
                      <hr style="margin:5px 0 5px 0">
                      <p class="t-text" v-if="bottle.appellation">{{bottle.appellation}}</p>
                      <p class="t-text" v-if="bottle.classification">{{bottle.classification}}</p>
                    </div>
                    <b-button pill
                      style="top:10px"
                      class="delete-button"
                      v-on:click.stop="onDelete(index)"
                      v-b-tooltip.hover :title="translate('delete bottle from wishlist')"
                    >
                      <font-awesome-icon class="delete-symbol" icon="trash-alt" />
                    </b-button>
                    <b-button pill
                      style="top:48px"
                      class="edit-button"
                      v-on:click.stop="onEdit(bottle._id)"
                      v-b-tooltip.hover title="edit bottle in wishlist"
                    >
                      <font-awesome-icon class="edit-symbol" icon="edit" />
                    </b-button>
                    <!-- <b-button v-if="allowBuy" pill
                      style="top:48px"
                      class="buy-button"
                      v-on:click.stop="onBuy(index)"
                      v-b-tooltip.hover title="buy bottle from wishlist"
                    >
                      <font-awesome-icon class="buy-symbol" icon="arrow-right" />
                    </b-button> -->
                    <div
                      v-if="allowBuy"
                      style="position:absolute;top:168px;right: 10px;height: 28px;width: 28px;"
                      v-on:click.stop="onBuy(index)"
                      v-b-tooltip.hover title="buy bottle from wishlist"
                    >
                      <font-awesome-icon style="font-size:18px;color:rgb(112,112,112)" icon="shopping-cart" />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br>
          </b-col>
        </b-row> 
        <br>
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                    <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                    Nederlands (Dutch)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('pt')">
                    <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                    Português (Portuguese)
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>
        </b-sidebar>        
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
    <b-modal id="addEntry" ref="addEntry" :title="translate('add wine to ...')" @ok="onSave">
      <b-row>
        <b-col
          class="w-tile m-2 d-inline-flex justify-content-center"
          style ="display:block; min-width:300px; margin:20px !important"
        >
          <b-row 
            style="width:100%"
          >
            <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
              <b-img center v-if="current_bottle.image_files.length > 0"
                style="height:100%;width:auto;position:absolute;right:0px"
                v-bind:src="current_bottle.image_files[0].dataURL" 
              ></b-img>
              <b-img center v-else
                style="height:100%;width:auto;position:absolute;right:0px"
                :src="require('@/assets/img/bottle.png')"
              ></b-img>
            </b-col>
            <b-col cols="9" class="d-table-cell">
              <div>
                <p class="t-title">{{current_bottle.name}}</p>
                <p class="t-subtitle" v-if="current_bottle.type">{{current_bottle.type}}</p>
                <hr>
                <p class="t-text" v-if="current_bottle.appellation">{{current_bottle.appellation}}</p>
                <p class="t-text" v-if="current_bottle.classification">{{current_bottle.classification}}</p>
                <p class="t-smalltext" v-if="current_bottle.grapes">{{current_bottle.grapes}}</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-container fluid >
          <div style="padding:0 15px 0 15px">
            <b-form autocomplete="off">
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label w-required" for="nicheList">{{ translate("unit") }}</label>        
                    <model-select
                      class="w-select"
                      :options="niches"
                      v-model="niche_id"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.nicheValid}"
                      aria-describedby="input-live-help input-live-feedback"
                    >
                    </model-select>
                    <b-form-invalid-feedback id="input-live-feedback">
                      {{nicheFeedback}}
                    </b-form-invalid-feedback>  
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label w-required" for="input-number">{{ translate("number") }}</label>
                    <b-form-spinbutton v-if="!entryExists" 
                      class="w-spinbutton" 
                      id="input-number" 
                      v-model="transaction.number"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.numberValid}"
                      aria-describedby="input-live-help input-live-feedback" 
                      min="1" max="1000"
                    >
                    </b-form-spinbutton>
                    <b-form-spinbutton v-else 
                      class="w-spinbutton" 
                      id="input-number" 
                      v-model="transaction.number"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.numberValid}"
                      aria-describedby="input-live-help input-live-feedback" 
                      min="1" max="1000"
                      readonly
                    >
                    </b-form-spinbutton>
                    <b-form-invalid-feedback id="input-live-feedback">
                      {{numberFeedback}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label w-required" for="input-date">{{ translate("date") }}</label>
                    <b-form-datepicker 
                      class="w-datepicker mb-2" 
                      id="input-date"
                      :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                      v-model="transaction.date"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.dateValid}"
                      aria-describedby="input-live-help input-live-feedback"
                    >                  
                    </b-form-datepicker>
                    <b-form-invalid-feedback id="input-live-feedback">
                      {{dateFeedback}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>                     
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label w-required" for="vintageList">{{ translate("vintage") }}</label>         
                    <model-select 
                      id="vintageList"
                      class = "w-select"
                      :options="vintages"
                      v-model="entry.vintage"
                      v-bind:class="{'form-control':true, 'is-invalid' : !this.vintageValid}"
                      @input="inputVintage"
                    >
                    </model-select>             
                    <b-form-invalid-feedback id="input-live-feedback">
                      {{vintageFeedback}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label" for="input-price">{{ translate("price") }}</label>
                    <b-form-input
                      id="input-price"
                      class="w-input"
                      v-model="transaction.price"
                      ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group style="text-align:left">
                    <label class="w-label" for="input-occasion">{{ translate("occasion") }}</label>
                    <b-form-input
                      id="input-occasion"
                      class="w-input"
                      v-model="transaction.description"
                      ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group style="text-align:left;display: flex">     
                <b-form-checkbox 
                  id="wishlistToggle"
                  v-model="removeFromWishList"
                  style="flex: 1"
                >
                <label class="w-label" for="wishlistToggle">{{ translate("remove from wishlist") }}</label>
                </b-form-checkbox>
              </b-form-group>              
            </b-form>                                  
          </div>
        </b-container>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">
          <b-button class="w-button-green-full" @click="ok()">
            {{ translate("save") }}
          </b-button>
        </b-row>   
        <b-row style="width:100%">
          <b-button class="w-button-pink-full" @click="cancel()">
            {{ translate("cancel") }}
          </b-button>
        </b-row>
        <br>
      </template>
    </b-modal>
    <b-modal id="deleteBottle" ref="deleteBottle" :title="translate('delete bottle from wishlist')" @ok="deleteBottle">
      <b-row>
        <b-col
          class="w-tile m-2 d-inline-flex justify-content-center"
          style ="display:block; margin:20px !important"
        >
          <b-row 
            style="width:100%"
          >
            <b-col cols="3" class="justify-content-center" style="height:100%;width:auto;padding:0">
              <b-img center v-if="current_bottle.image_files.length > 0"
                style="height:100%;width:auto;position:absolute;right:0px"
                v-bind:src="current_bottle.image_files[0].dataURL" 
              ></b-img>
              <b-img center v-else
                style="height:100%;width:auto;position:absolute;right:0px"
                :src="require('@/assets/img/bottle.png')"
              ></b-img>
            </b-col>
            <b-col cols="9" class="d-table-cell">
              <div>
                <p class="t-title">{{current_bottle.vintage}}</p>
                <p class="t-title" style="margin:0">{{current_bottle.name}}</p>
                <p v-if="current_bottle.type" class="t-subtitle" >{{current_bottle.type}}</p>
                  <p v-else class="t-subtitle" style="color:white">bogus text here</p>
                <hr>
                <p class="t-text" v-if="current_bottle.appellation">{{current_bottle.appellation}}</p>
                <p class="t-text" v-if="current_bottle.classification">{{current_bottle.classification}}</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <p class="t-title text-center" style="margin-left=20px;margin-right:20px">{{ translate("ARE YOU SURE YOU WANT TO DELETE THIS BOTTLE FROM YOUR WISHLIST?") }}</p>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-row style="width:100%">
          <b-button @click="ok()" class="w-button-green-full">{{ translate("ok") }}</b-button>
        </b-row>   
        <b-row style="width:100%">
          <b-button  @click="cancel()" class="w-button-pink-full">{{ translate("cancel") }}</b-button>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import { ModelSelect } from 'vue-search-select';

  import NoAccess from '@/components/NoAccess.vue'
  import Menu from '@/components/MenuMobile.vue'

  import Users from '../Users.js'
  import WishLists from '../WishLists.js'
  import Bottles from '../Bottles.js'
  import Wines from '../Wines.js'
  import C_Wines from '../C_Wines.js'

  import Cellars from '../Cellars.js'
  import Niches from '../Niches.js'
  import Entries from '../Entries.js'
  import Transactions from '../Transactions.js'

  export default {
    name: "WishList",
    components: {
      NoAccess,
      Menu,
      ModelSelect,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },
    },
    data() {
      return {
        debug: false,
        isLoading : true,

        allowBuy: true,

        wishlist:{},
        wishlist_id:0,

        bottles: [],
        current_bottle: {
          name:'',
          vintage:0,

          wine_id:0,
          c_wine_id:0,

          type:'',
          appellation:'',
          classification:'',
          grapes:'',
          image_files:[],
        },
        current_bottle_id:0,

        removeFromWishList: true,

        // Stuff for the addEntry Modal - if (this.allowBuy)
        cellar_id:0,
        cellar: {},

        niche_id:0,
        niche:{},
        niches:[],

        vintages: [],

        entry: {
            name:'',
            type:'',
            country_id:0,
            country:'',
            region_id:0,
            region:'',
            appellation_id:0,
            appellation:'',
            classification_id:0,
            classification:'',
            sparkling:false,
            color:'',
            grapes:'',
            vines:'',
            yields:'',
            vinification:'',
            image_files:[],
            wine_id:0,
            winery_id:0,
            
            number:0,
            vintage:0,

            cellar_id:0,
            niche_id:0,

            transaction_ids:[],
            tasting_note_ids:[],
        },
        entry_id:0,
        entryExists: false,

        transaction:{
          date:'',
          number:0,
          description:'',
          price:'',
          entry_id:0
        },
        transaction_id:0,

        // Validation Logic
        numberValid : true,
        numberFeedback : '',
        dateValid : true,
        dateFeedback : '',
        vintageValid : true,
        vintageFeedback : '',
        nicheValid: true,
        nicheFeedback: "",

        isValid : true,
      }
    }, 

    async mounted() {
      let local_debug = false

      let time_0 = new Date().getTime()

      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("WishList.mounted: START")

      this.user_id = this.currentUserID
      this.user = this.currentUser

      this.$store.commit('setContext', 'WishList')

      // Load or create wishlist
      if (
        typeof this.user.wishlist_id !== "undefined" &&
        this.user.wishlist_id.length === 24
      ) {
        this.wishlist_id = this.user.wishlist_id

        try {
          this.wishlist = await WishLists.getone(this.wishlist_id)
          delete this.wishlist._id
        } catch (error) {
          if (local_debug || this.debug) console.log("WishList.mounted: WishLists.getone", error)
        }

      } else {
        this.wishlist.user_id = this.user_id
        this.wishlist.bottle_ids = []

        try {
          this.wishlist_id = await WishLists.create(this.wishlist)
          this.user.wishlist_id = this.wishlist_id
          await Users.update(this.user_id, this.user)
        } catch (error) {
          if (local_debug || this.debug) console.log("WishList.mounted: create wishlist/update user", error)
        }
      }

      // Load bottles + wine data
      const validBottleIds = (this.wishlist.bottle_ids || []).filter(
        id => id && id.length === 24
      )

      if (validBottleIds.length > 0) {
        try {
          this.bottles = await Bottles.getmany(validBottleIds)
          this.bottles = this.bottles.filter(
            bottle => bottle && typeof bottle === "object"
          )

          const wineIds = this.bottles
            .filter(bottle => bottle.wine_id && bottle.wine_id !== 0)
            .map(bottle => bottle.wine_id)

          const cWineIds = this.bottles
            .filter(bottle => bottle.c_wine_id && bottle.c_wine_id !== 0)
            .map(bottle => bottle.c_wine_id)

          const [wines, cWines] = await Promise.all([
            wineIds.length > 0 ? Wines.getmany(wineIds) : Promise.resolve([]),
            cWineIds.length > 0 ? C_Wines.getmany(cWineIds) : Promise.resolve([])
          ])

          const wineMap = {}
          wines.forEach(wine => {
            wineMap[wine._id] = wine
          })

          const cWineMap = {}
          cWines.forEach(wine => {
            cWineMap[wine._id] = wine
          })

          this.bottles = this.bottles.map(bottle => {
            const wine = bottle.wine_id && bottle.wine_id !== 0
              ? wineMap[bottle.wine_id]
              : cWineMap[bottle.c_wine_id]

            if (!wine) return bottle

            return {
              ...bottle,
              name: wine.name,
              color: wine.color,
              type: wine.type || '',
              appellation: wine.appellation || '',
              classification: wine.classification || '',
              image_files: wine.image_files && wine.image_files.length > 0
                ? [wine.image_files[0]]
                : []
            }
          })

        } catch (error) {
          if (local_debug || this.debug) console.log("WishList.mounted: loading bottles/wines", error)
        }
      }

      this.$store.commit('setWishlist', this.wishlist)
      this.$store.commit('setWishlistID', this.wishlist_id)

      if (this.allowBuy) {
        // Load the Cellar
        if (this.currentCellarLoaded) {
          this.cellar = this.currentCellar
          this.cellar_id = this.currentCellarID
        } else {
          this.cellar_id = this.user.cellar_id

          try {
            this.cellar = await Cellars.getone(this.cellar_id)
            delete this.cellar._id

            this.$store.commit('setCellar', this.cellar)
            this.$store.commit('setCellarID', this.cellar_id)
            this.$store.commit('setCellarLoaded', true)
          } catch (error) {
            if (local_debug || this.debug) console.log("WishList.mounted: Cellars.getone", error)
          }
        }

        // Load the niches list
        if (this.cellar.niche_ids && this.cellar.niche_ids.length > 0) {
          try {
            const validNicheIds = this.cellar.niche_ids.filter(
              id => id && id.length === 24
            )

            const nicheResponses = await Niches.getmany(validNicheIds)

            this.niches = nicheResponses
              .filter(niche => niche && typeof niche === "object")
              .map(niche => ({
                value: niche._id,
                text: niche.code + ' - ' + niche.name
              }))
              .sort((a, b) => a.text.localeCompare(b.text))

          } catch (error) {
            if (local_debug || this.debug) console.log("WishList.mounted: Niches.getmany", error)
          }
        }

        this.init_transaction()
      }

      this.isLoading = false

      if (local_debug || this.debug) console.log("WishList.mounted: STOP")

      let time_1 = new Date().getTime()
      console.log("Loading time new: ", time_1-time_0)
    },

    methods: {
      async onEdit(bottle_id) {
        let local_debug = false
        if (local_debug || this.debug) console.log("")
        if (local_debug || this.debug) console.log("WishList.onEdit - START")
        if (local_debug || this.debug) console.log("WishList.onEdit - bottle_id = ", bottle_id)
        this.current_bottle_id = bottle_id;
        if (bottle_id == 0) {
          this.init();
          this.$store.commit('setPage','BottleEdit')
          this.$router.push({path:'/BottleEdit'});
        } else {
          this.bottle_id = bottle_id
          await Bottles.getone(this.bottle_id)
          .then(response => {
            this.bottle = response
            delete this.bottle._id
            if (local_debug || this.debug) console.log("WishList.onEdit: Bottle ", this.bottle, " succesfully fetched from DB")
          })
          .catch(error =>{
            if (local_debug || this.debug) console.log("WishList.onEdit: Bottles.getone failed with ERROR ", error)
          })
          this.c_wine_id = this.bottle.c_wine_id
          this.wine_id = this.bottle.wine_id
          if ( this.c_wine_id !=0 ) {
            await C_Wines.getone(this.c_wine_id)
            .then(response => {
              this.c_wine = response
              delete this.c_wine._id
              if (typeof this.c_wine.sweet == "undefined") {
                this.c_wine.sweet = false
              }
              if (local_debug || this.debug) console.log("WishList.onEdit: C_Wine ", this.c_wine, " succesfully fetched from DB")
            })
            .catch(error =>{
              if (local_debug || this.debug) console.log("WishList.onEdit: C_Wines.getone failed with ERROR ", error)
            })
          }
          if ( this.wine_id !=0 ) {
            await Wines.getone(this.wine_id)
            .then(response => {
              this.wine = response
              delete this.wine._id
              if (typeof this.wine.sweet == "undefined") {
                this.wine.sweet = false
              }
              if (local_debug || this.debug) console.log("WishList.onEdit: Wine ", this.wine, " succesfully fetched from DB")
            })
            .catch(error =>{
              if (local_debug || this.debug) console.log("WishList.onEdit: Wines.getone failed with ERROR ", error)
            })
          }

          this.$store.commit('setCWine',this.c_wine)
          this.$store.commit('setCWineID',this.c_wine_id)
          this.$store.commit('setWine',this.wine)
          this.$store.commit('setWineID',this.wine_id)
          this.$store.commit('setBottle',this.bottle)
          this.$store.commit('setBottleID',this.bottle_id)


          if ( this.c_wine_id !=0) {
            this.$store.commit('setPage','BottleEdit')
            this.$router.push({path:'/BottleEdit'});
          }
          else if ( this.wine_id !=0) {
            this.$store.commit('setPage','BottleShow')
            this.$router.push({path:'/BottleShow'});
          }
          else {
            alert("SEVERE ERROR - current_bottle has no wine_id nor c_wine_id!")
          }
        }

        if (local_debug || this.debug) console.log("WishList.onEdit - STOP")
      },

      async onSelect(index) {
        if (this.debug) console.log("")
        if (this.debug) console.log("WishList.onSelect - START")
        if (this.debug) console.log("WishList.onSelect - bottle_id = ", bottle_id)
        if (this.debug) console.log("WishList.onSelect - STOP")
      },

      async onDelete(index) {
        if (this.debug) console.log("")
        if (this.debug) console.log("WishList.onDelete - START")
        if (this.debug) console.log("WishList.onDelete - index = ", index)
        if (this.debug) console.log("WishList.onDelete - bottles[",index,"] = ", this.bottles[index])
        this.current_bottle = this.bottles[index]
        this.current_bottle_id = this.bottles[index]._id;
        await this.$bvModal.show('deleteBottle')        
        if (this.debug) console.log("WishList.onDelete - STOP")
      },

      async deleteBottle() {
        if (this.debug) console.log("")
        if (this.debug) console.log("WishList.deleteBottle - START")
        let i = this.wishlist.bottle_ids.indexOf(this.current_bottle_id)
        this.wishlist.bottle_ids.splice(i,1)
        await WishLists.update(this.wishlist_id,this.wishlist)
        .then(response=>{
          if (this.debug) console.log("========> WishList.deleteBottle: current_bottle_id ",this.current_bottle_id," succesfully removed to wishlist ", this.wishlist, " with wishlist_id ",this.wishlist_id," with response ", response);
        })
        .catch(error=>{
          if (this.debug) console.log("========> WishList.deleteBottle: catch await Wishlist.update ", error);
        })  
        this.bottles.splice(i,1)
        if (this.debug) console.log("WishList.deleteBottle - STOP")
      },

      async onBuy(index) {
        if (this.debug) console.log("")
        if (this.debug) console.log("WishList.onBuy - START")
        if (this.debug) console.log("WishList.onBuy - index = ", index)
        if (this.debug) console.log("WishList.onBuy - bottles[",index,"] = ", this.bottles[index])
        this.current_bottle = this.bottles[index]
        this.current_bottle_id = this.bottles[index]._id;
        this.entry.vintage = this.current_bottle.vintage
        this.niche_id = 0
        this.removeFromWishList = true
        if (this.debug) console.log("WishList.onBuy - current_bottle = ", this.current_bottle)
        this.init_transaction()
        await this.$bvModal.show('addEntry')
        if (this.debug) console.log("WishList.onBuy - STOP")
      },

      async onSave(event){
        if (this.debug) console.log("")
        if (this.debug) console.log("WishList.onSave - START")
        if (this.debug) console.log("WishList.onSave - event = ", event)
        //Reading the form
        this.validate_form()
        if (!this.isValid) {
          if (this.debug) console.log("WineList.onSave: Returning without Save because validation form failed.")
          event.preventDefault()
          return 
        }
        if (this.debug) console.log("WishList.onSave - current_bottle = ", this.current_bottle)

        // Load niche
        await Niches.getone(this.niche_id)
        .then(response => {
          this.niche = response
          delete this.niche._id
          if (this.debug) console.log("WishList.onSave: Niche ",this.niche, " with id ",this.niche_id," succesfully fetched from DB with response ", response);
        })
        .catch(error => {
          if (this.debug) console.log("WishList.onSave: await Niches.getone", error);
        })        

        // Create entry
        if (this.current_bottle.wine_id !=0) {
          await Wines.getone(this.current_bottle.wine_id)
          .then(response => {
            if (this.debug) console.log("WishList.onSave: Wine ",response, " with id ",response._id," succesfully fetched from DB.");
            this.entry.name = response.name
            this.entry.type = response.type
            this.entry.country_id = response.country_id
            this.entry.country = response.country
            this.entry.region_id = response.region_id
            this.entry.region = response.region
            this.entry.appellation_id = response.appellation_id
            this.entry.appellation = response.appellation
            this.entry.classification_id = response.classification_id
            this.entry.classification = response.classification
            this.entry.sparkling = response.sparkling
            this.entry.color = response.color
            this.entry.grapes = response.grapes
            this.entry.vines = response.vines
            this.entry.yields = response.yields
            this.entry.vinification = response.vinification
            this.entry.image_files = response.image_files
            this.entry.wine_id = response._id
            this.entry.c_wine_id = 0
            this.entry.winery_id = response.winery_id
            this.entry.number = this.transaction.number
            // vintage read from form
            this.entry.cellar_id = this.cellar_id
            this.entry.niche_id = this.niche_id
          })
          .catch(error => {
            if (this.debug) console.log("WishList.onSave: await Wines.getone", error);
          })
        } else if (this.current_bottle.c_wine_id !=0) {
          await C_Wines.getone(this.current_bottle.c_wine_id)
          .then(response => {
            if (this.debug) console.log("WishList.onSave: C_Wine ",response, " with id ",response._id," succesfully fetched from DB.");
            this.entry.name = response.name
            this.entry.type = response.type
            this.entry.country_id = response.country_id
            this.entry.country = response.country
            this.entry.region_id = response.region_id
            this.entry.region = response.region
            this.entry.appellation_id = response.appellation_id
            this.entry.appellation = response.appellation
            this.entry.classification_id = response.classification_id
            this.entry.classification = response.classification
            this.entry.sparkling = response.sparkling
            this.entry.color = response.color
            this.entry.grapes = response.grapes
            this.entry.vines = response.vines
            this.entry.yields = response.yields
            this.entry.vinification = response.vinification
            this.entry.image_files = response.image_files
            this.entry.wine_id = 0
            this.entry.winery_id = 0
            this.entry.c_wine_id = response._id
            this.entry.number = this.transaction.number
            // vintage read from form
            this.entry.cellar_id = this.cellar_id
            this.entry.niche_id = this.niche_id
          })
          .catch(error => {
            if (this.debug) console.log("WishList.onSave: await C_Wines.getone", error);
          })
        } else {
          alert("SEVERE ERROR - current_bottle has no wine_id nor c_wine_id!")
          return
        }

        // Check if entry already exists in database 
        await this.getEntry_inNiche(this.entry);
        if (this.debug) console.log("WishList.onSave: entry_id = ", this.entry_id);
        if (this.debug) console.log("WishList.onSave: entry = ", this.entry);
        if ( this.entry_id == 0 ) {
          if (this.debug) console.log("WishList.onSave: Entry does NOT exist - we create it");

          // Updating a transaction from form data
          this.entry.number = this.transaction.number;
          
          // Creating Entry
          await Entries.create(this.entry)
          .then(response=> {
            this.entry_id = response
            if (this.debug) console.log( "WishList.onSave: Entry ", this.entry, " with id ",this.entry_id," succesfully created.");
          })
          .catch(error=> {
            if (this.debug) console.log("WishList.onSave: await Entries.create", error);
          })

          // Adding this.entry_id to the list of this.niche
          if (this.debug) console.log("WishList.onSave: Adding entry to entry_ids from niche ", this.niche.name)       
          this.niche.entry_ids.push(this.entry_id);
          await Niches.update(this.niche_id,this.niche)
          .then(response=>{
            if (this.debug) console.log("WishList.onSave: Niche succesfully added entry : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("WishList.onSave: catch await Niche.update ", error);
          })  
          
          // Adding this.entry_id to the list of this.cellar
          if (this.debug) console.log("WishList.onSave: Adding entry to entry_ids from cellar ", this.cellar.name)
          this.cellar.entry_ids.push(this.entry_id);
          await Cellars.update(this.cellar_id,this.cellar)
          .then(response=>{
            if (this.debug) console.log("WishList.onSave: Cellar succesfully added niche : id = ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("WishList.onSave: catch await Cellar.update ", error);
          })  
        } else {
          if (this.debug) console.log("WishList.onSave: Entry DOES exist - we update it");
          if (this.debug) console.log("WineShow.onSave: Entry DOES exist: id = ", this.entry_id, " ", this.entry);
          this.entry.number = this.entry.number + this.transaction.number
        }

        this.transaction.entry_id = this.entry_id
        await Transactions.create(this.transaction)
        .then(response=> {
          this.transaction_id = response
          if (this.debug) console.log( "WishList.onSave: Transaction ", this.transaction, " with id ",this.transaction_id," succesfully created.");
        })
        .catch(error=> {
          if (this.debug) console.log("WishList.onSave: await Transactions.create", error);
        })

        this.entry.transaction_ids.push(this.transaction_id)
        await Entries.update(this.entry_id, this.entry)
        .then(response=> {
          if (this.debug) console.log( "WishList.onSave: Entry ", this.entry, " with id ",this.entry_id," succesfully updated with response = ", response);
        })
        .catch(error=> {
          if (this.debug) console.log("WishList.onSave: await Entries.update", error);
        })

        this.niche.number_of_bottles = this.niche.number_of_bottles + this.transaction.number
        await Niches.update(this.niche_id, this.niche)
        .then(response=> {
          if (this.debug) console.log( "WishList.onSave: Niche ", this.niche, " with id ",this.niche_id," succesfully updated with response = ", response);
        })
        .catch(error=> {
          if (this.debug) console.log("WishList.onSave: await Niches.update", error);
        })

        await Cellars.update(this.cellar_id, this.cellar)
        .then(response=> {
          if (this.debug) console.log( "WishList.onSave: Cellar ", this.cellar, " with id ",this.cellar_id," succesfully updated with response = ", response);
        })
        .catch(error=> {
          if (this.debug) console.log("WishList.onSave: await Cellars.update", error);
        })

        if (this.removeFromWishList) { 
          let i = this.wishlist.bottle_ids.indexOf(this.current_bottle_id)
          this.wishlist.bottle_ids.splice(i,1)
          await WishLists.update(this.wishlist_id,this.wishlist)
          .then(response=>{
            if (this.debug) console.log("========> WishList.onSave: current_bottle_id ",this.current_bottle_id," succesfully removed to wishlist ", this.wishlist, " with wishlist_id ",this.wishlist_id," with response ", response);
          })
          .catch(error=>{
            if (this.debug) console.log("========> WishList.onSave: catch await Wishlist.update ", error);
          })  
          this.bottles.splice(i,1)
          if (this.debug) console.log("WishList.onSave: i = ",i,"Removed from Wishlist");
        } else {
          if (this.debug) console.log("WishList.onSave: Stays on Wishlist");
        }

        if (this.debug) console.log("WishList.onSave - STOP")
      },

      validate_form(){
        if ( this.transaction.date == '') {
          this.dateValid=false;
          this.dateFeedback='Choose a valid date';
        } else {
          this.dateValid=true;
          this.dateFeedback='';
          // format date yyyy-mm-dd
          let dateArray = this.transaction.date.split("-");
          if (dateArray[1].length == 1) {
            dateArray[1] = "0" + dateArray[1]
          }
          if (dateArray[2].length == 1) {
            dateArray[2] = "0" + dateArray[2]
          }
          this.transaction.date = dateArray[0] + "-" + dateArray[1] + "-" + dateArray[2]
        }

        if ( this.niche_id == 0 ) {
          this.nicheValid = false
          this.nicheFeedback = "select valid niche"
        } else {
          this.nicheValid = true
          this.nicheFeedback = ""
        }

        if( this.transaction.number <= 0) {
            this.numberValid = false;
            this.numberFeedback = "Select valid number"
        } else {
            this.numberValid = true
            this.numberFeedback = ""
        }

        if(this.entry.vintage == 0) {
          this.vintageValid = false;
          this.vintageFeedback = "Select valid vintage"
        } 
        else {
          this.vintageValid = true;
          this.vintageFeedback = ""
        }
        
        this.isValid = this.nicheValid && this.numberValid && this.vintageValid;
      },
      async inputVintage(value) {
        this.entry.vintage = value;
        if (this.debug) console.log("WishList in inputVintage - vintage = ",this.entry.vintage)
      },

      async getEntry_inNiche(entry){    
        let local_debug = false
        if (local_debug) console.log("");
        if (local_debug) console.log("====> WishList.getEntry_inNiche: START");
        if (local_debug) console.log("====> WishList.getEntry_inNiche: entry = ", entry);
        let test_entry_id = 0;
        let test_entry = {};
        for(let i=0; i < this.niche.entry_ids.length; i ++) {
          await Entries.getone(this.niche.entry_ids[i])
          .then(response => {
            test_entry = response;
            test_entry_id = response._id;
            delete test_entry._id
          })
          .catch(error => {
            if (local_debug) console.log("====> WishList.getEntry_inNiche: await Entries.getone ", error);
          })
          if (local_debug) console.log("====> WishList.getEntry_inNiche: testing entry with id = ", test_entry_id);
          if (entry.wine_id != 0) {
            if (test_entry.wine_id === entry.wine_id && test_entry.vintage === entry.vintage) {
              if (local_debug) console.log("====> WishList.getEntry_inNiche: entry.wine_id=",entry.wine_id," entry.vintage=",entry.vintage, " EXISTS");
              this.entry_id = test_entry_id;
              this.entry = test_entry;
              if (local_debug) console.log("====> WishList.getEntry_inNiche: STOP");
              return test_entry_id;
            }
          } else if (entry.c_wine_id != 0) {
            if (test_entry.c_wine_id === entry.c_wine_id && test_entry.vintage === entry.vintage) {
              if (local_debug) console.log("====> WishList.getEntry_inNiche: entry.c_wine_id=",entry.c_wine_id," entry.vintage=",entry.vintage, " EXISTS");
              this.entry_id = test_entry_id;
              this.entry = test_entry;
              if (local_debug) console.log("====> WishList.getEntry_inNiche: STOP");
              return test_entry_id;
            }
          } else {
            if (local_debug) console.log("====> WishList.getEntry_inNiche: SEVERE ERROR - no wine_id or c_wine_id");
            if (local_debug) console.log("====> WishList.getEntry_inNiche: STOP");
            return 0;
          }
        }
        if (local_debug) console.log("====> WishList.getEntry_inNiche: entry = ",entry," entry.vintage=",entry.vintage, " DOES NOT EXISTS");
        if (local_debug) console.log("====> WishList.getEntry_inNiche: STOP");
        return 0;
      },

      init_transaction() {
        var today = new Date();
        var this_year = today.getFullYear();
        for (let i = this_year; i > this_year-100; i--) {
          this.vintages.push({value:i,text:i});
        }
        this.transaction.date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        this.transaction.number = 0;
        this.transaction.price = '';
        this.transaction.description = ''
      },

      init() {
        this.bottle = {
          vintage:"",
          name:"",
          wine_id:0,
          c_wine_id:0,
          wishlist_id: this.wishlist_id 
        };
        this.bottle_id=0;

        this.c_wine = {};
        this.c_wine_id = 0;

        this.wine = {}
        this.cwine_id = 0;

        this.$store.commit('setBottle',this.bottle)
        this.$store.commit('setBottleID',this.bottle_id)

        this.$store.commit('setWine',this.wine)
        this.$store.commit('setWineID',this.wine_id)

        this.$store.commit('setCWine',this.c_wine)
        this.$store.commit('setCWineID',this.c_wine_id)
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
      })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },

      doNothing() {
      },
    },
  }     
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>
